// extracted by mini-css-extract-plugin
export default {"label":"Label__label--1E9","readOnly":"Label__readOnly--28C","hint":"Label__hint--3uU","fieldLabelAsterisk":"Label__fieldLabelAsterisk--lBk","tooltipIcon":"Label__tooltipIcon--23s"};